// extracted by mini-css-extract-plugin
export default {"searchTagsWrapper":"_655250ff"};